import { SurveyReportScoringRanges } from '../../../api/services/user_assignment_codes/types.ts'

export const getScoreRangeIndex = <T extends { min_score: number; max_score: number }>(
  items: T[],
  value: number
): number => {
  return items.findIndex((item) => value >= item.min_score && value <= item.max_score)
}

export const getAveragePercentagePatients = (
  items: SurveyReportScoringRanges[],
  totalPatients: number
) => {
  if (totalPatients === 0) {
    return items.map(() => 0)
  }

  return items.map((item) => Math.round(((item.patients.length / totalPatients) * 100) * 100) /100)
}